<h4>Ingresar</h4>
<hr>
<mat-form-field *ngIf="step == 0" appearance="outline" required>
    <mat-label>Documento / DNI</mat-label>
<input #inputDNI matInput onlyNumber type="text" placeholder="Documento" name="document_login" [(ngModel)]="documentInput"
    (keydown.enter)="onLogin()" cdkFocusInitial />
    <span matSuffix class="jam jam-user"></span>
</mat-form-field>

<p *ngIf="step == 1">Tu cuenta no tiene un email asociado, ingresalo para que podamos enviarte la contraseña:</p>
<mat-form-field *ngIf="step == 1" appearance="outline" required>
    <mat-label>Ingresa tu email</mat-label>
    <input matInput type="text" placeholder="Ingresa tu email" name="email_login" [(ngModel)]="emailInput"  />
    <span matSuffix class="jam jam-user"></span>
</mat-form-field>

<mat-form-field *ngIf="step == 2" appearance="outline" required>
    <mat-label>Ingresar contraseña</mat-label>
    <input matInput #inputPass [type]="hide ? 'password' : 'text'" [(ngModel)]="passInput" (keydown.enter)="onLogin()" />
    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <span class="jam {{hide ? 'jam-eye' : 'jam-eye-close'}}"></span>
        <!-- <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon> -->
    </button>
</mat-form-field>

<button mat-button (click)="onLogin()">
    <ng-container *ngIf="!isSending">
        Ingresar
    </ng-container>
    <ng-container *ngIf="isSending">
        Cargando...
    </ng-container>
</button>

<div class="settings">
    <mat-checkbox *ngIf="step == 2">Recordar</mat-checkbox>
    <a href="#" (click)="onClickRecovery()" >Olvidé mi contraseña</a>
    
</div>
<div >
    <a href="#" (click)="onContact()" >¿Sos nuevo? Asociate!</a>
</div>
<div>
    <a href="#" style="color:BLACK;"><span *ngIf="step == 2" class="jam jam-arrow-left" data-inline="false" (click)="onClickBack()"></span></a>
</div>

<!--<h4><span>Ingresar con:</span></h4>
<hr>
<button mat-button class="facebook"><span class="jam jam-facebook"></span> Facebook</button>
<button mat-button class="google"><span class="jam jam-google"></span> Google+</button>-->

<swal #inputEmail (confirm)="onRecovery($event)" title="Ingresa tu email!" text="Te enviaremos los pasos para recuperar tu contraseña!" type="input" inputPlaceholder="Ingresar tu email" input="email"
  validationMessage="Ingrese un email válido">
</swal>
<swal #loginNewError (confirm)="onContact()" title="Error"
      text="No pudimos encontrar un asociado con el número de DNI indicado.
      Para poder comprar en Plaza Hogar tenés que ser socio de la Asociación Mutual de Venado Tuerto.
      Completá el formulario y te contactaremos a la brevedad."
      confirmButtonText="Formulario de Contacto"
       type="error" icon="warning" [showCancelButton]="true"
       [cancelButtonText]="'Cancelar'">
</swal>
